<template>
    
<app-modal v-on:close="$emit('close')" :loading="is.loading" :forceClose="true" :prompt="true" :title="settings.share_title" :description="settings.share_description" class="share">

    <template v-slot:foot>

		<div class="platforms">
			<a :href="url" target="_blank" class="platforms-item" :class="{[classBrand(key)]: true}" v-for="(url, key) in platforms" :key="key" v-tooltip="'Share to ' + key"><app-icon :name="key" /></a>
		</div>

    </template>

</app-modal>

</template>

<script>

import mixinModal from '@/mixin/modal.js'

import Vue from 'vue'

export default {

	mixins: [mixinModal],

	data: function() {

		return {
			is: {
				loading: false
			},
			platforms: {}
		}

	},
	
	created: function() {

		this.is.loading = true

		this.$api.request('share', {
			type: this.params.type,
			identity: this.params.identity
		}).then(function(json) {

			Vue.set(this, 'platforms', json.platforms)

			this.is.loading = false

		}.bind(this), function() {

			this.$emit('close')

		}.bind(this))

	},

	methods: {
		
		classBrand: function(key) {

			return 'brand-' + key

		}

	}
    
}

</script>

<style scoped>

.platforms {
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
	flex-wrap: wrap;
}

.platforms-item {
	width: 64px;
	height: 64px;
	text-align: center;
	line-height: 64px;
	font-size: 32px;
	color: #fff;
	margin: 5px;
	transition: all 100ms linear;
}

.is-desktop .platforms-item:hover {
    transform: scale(1.1);
}

.platforms-item.brand-facebook {
	background-color: var(--color-brand-facebook);
}

.platforms-item.brand-twitter {
	background-color: var(--color-brand-twitter);
}

.platforms-item.brand-pinterest {
	background-color: var(--color-brand-pinterest);
}

</style>